import { AttributeInput, MasterPropertyData } from "services/interface";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
} from "antd";
import { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import locale from 'antd/es/date-picker/locale/th_TH';

import dayjs from "dayjs";

interface ProductAttributeSelectProps {
  data: MasterPropertyData[];
  loading: boolean;
  handleFinish: (values: AttributeInput[]) => void;
  onClose: () => void;
  attributes?: AttributeInput[];
}

const { Option } = Select;

const ProductAttributeSelect: FC<ProductAttributeSelectProps> = ({
  data,
  loading,
  handleFinish,
  onClose,
  attributes,
}) => {
  const [attribute, setAttribute] = useState<MasterPropertyData[]>([]);

  const children: React.ReactNode[] = [];

  const [form] = Form.useForm();

  data.forEach((item) => {
    children.push(<Option key={item.id}>{item.name}</Option>);
  });

  const handleSelectAttribute = (value: string) => {
    const selectedAttribute = data.filter((item) => item.id === value);
    setAttribute([...attribute, ...selectedAttribute]);
  };

  const handleDeselectAttribute = (value: string) => {
    const selectedAttribute = data.filter((item) => item.id === value);
    setAttribute(
      attribute.filter((item) => item.id !== selectedAttribute[0].id)
    );
  };

  const onFinish = (values: any) => {
    const attributeInput: AttributeInput[] = [];
    attribute.forEach((item) => {
      attributeInput.push({
        property_id: item.id,
        value: values[item.id],
      });
    });
    handleFinish(attributeInput);
    onClose();
  };

  useEffect(() => {
    if (attributes) {
      
      // data filter with attributes and return selectedAttribute: MasterPropertyData[]
      const selectedAttribute: MasterPropertyData[] = [];
      data.forEach((item) => {
        attributes.forEach((attribute) => {
          if (item.id === attribute.property_id) {
            selectedAttribute.push({...item, value: attribute.value});
          }
        });
      });

      setAttribute(selectedAttribute);

      form.setFieldsValue({
        attribute: selectedAttribute.map((item) => item.id),
      });
    }
  }, [attributes]);

  return (
    <Form form={form} name="product_attribute" onFinish={onFinish}>
      <FormWrapper>
        <Form.Item name="attribute" label="คุณลักษณะสินค้า">
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="กรุณาเลือกคุณลักษณะสินค้า"
            optionFilterProp="children"
            showSearch
           // defaultValue={attribute.map((item) => item.id)}
            filterOption={false}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onSelect={handleSelectAttribute}
            onDeselect={handleDeselectAttribute}
          >
            {children}
          </Select>
        </Form.Item>
        {attribute.map((item) => {

          
          return (
            <Form.Item
              key={item.id}
              name={item.id}
              label={item.name}
              initialValue={convertValueTodate(item.type ,item.value)}
              rules={[
                {
                  required: true,
                  message: `กรุณากรอกข้อมูล${item.name}`,
                },
              ]}
            >
              {renderForm(item.type , `กรุณากรอกข้อมูล${item.name}`)}
            </Form.Item>
          );
        })}
      </FormWrapper>
      <FotterWrapper>
        <Button type="primary" htmlType="submit">
          บันทึกคุณลักษณะสินค้า
        </Button>
      </FotterWrapper>
    </Form>
  );
};

export default ProductAttributeSelect;

const renderForm = (type: string, placeholder: string) => {

  


  switch (type) {
    case "text":
      return <Input placeholder={placeholder} style={{ width: "100%" }} />;
    case "number":
      return (
        <InputNumber placeholder={placeholder} style={{ width: "100%" }} />
      );
    case "date":
      return (
        <DatePicker
          placeholder={placeholder}
          style={{ width: "100%" }}
          format={"YYYY-MM-DD"}
        />
       
      );
    default:
      return <Input placeholder={placeholder} style={{ width: "100%" }} />;
  }
};

const convertValueTodate = (type: string, value: string) => {
  if(type === "date"){
    return dayjs(value)
  }
  return value
} 

const FormWrapper = styled.div`
  width: 100%;
  height: 75vh;
  margin-top: 20px;
  overflow-y: auto;
`;

const FotterWrapper = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
